<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { EsportsTournamentList } from '@/api/games/esports_tournament';


export default {
    name: "esports-tournament-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: EsportsTournamentList,
        }
    }
}
</script>